import { Button, Col, Row } from "react-bootstrap";
import faultMessageImage from "../../../../assets/images/fault-message-image.png";
import Title from "../../../../components/title/Title";

interface IProps {
  referenceNo: string;
  handleClose: () => void;
  faultType: "bill" | "service";
}

const ServiceComplaintSuccessMessage = (props: IProps) => {
  return (
    <Row className="h-100 align-items-center">
      <Col className="text-center">
        <Title>Your complaint has been successfully captured.</Title>
        <Title fontSize={15} className="mb-0">
          {props.faultType === "bill"
            ? "Bill Complaint Reference No:"
            : "Fault Reference No:"}
        </Title>
        <Title fontSize={15} className="text-success" color="#2FD664">
          {props.referenceNo}
        </Title>
        <Title className="mb-5 mt-4">
          Our team will attend to your complaint soon. Thank you!
        </Title>
        <Button onClick={props.handleClose} variant="success">
          OK
        </Button>
      </Col>
      <Col>
        <img src={faultMessageImage} alt="fault message" />
      </Col>
    </Row>
  );
};

export default ServiceComplaintSuccessMessage;
